module.exports = __webpack_public_path__ + "source-sans-pro-v13-latin-regular.123352716b6df5cc7d06e6edb5f9554b.ttf";